const logger = {
  debug: (...args: unknown[]) => {
    if (import.meta.env.DEV) {
      globalThis.console?.debug?.(...args)
    }
  },
  info: (...args: unknown[]) => {
    if (import.meta.env.DEV) {
      globalThis.console?.info?.(...args)
    }
  },
  warn: (...args: unknown[]) => {
    globalThis.console?.warn?.(...args)
  },
  error: (...args: unknown[]) => {
    globalThis.console?.error?.(...args)
  }
}

export default logger
